import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-tyokielto-aseta-dialog',
  templateUrl: './tyokielto-aseta.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasAsetuksetTyokieltoAsetaDialog {
  constructor(private dialogRef: MatDialogRef<AsiakasAsetuksetTyokieltoAsetaDialog>) {}

  tallenna() {
    this.dialogRef.close(true)
  }
}
